export const listInvoiceItems = `
   query listInvoiceItems($filter: InvoiceItemsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listInvoiceItems(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
                id
                invoiceId
                customerId
                amount
                currency
                description
                period {
                    start
                    end
                }
                quantity
                unitAmount
                createdByUsername
                created
                updated
           }
           nextToken
       }
   }
`;

export const getInvoiceItem = `
   query getInvoiceItem($id: ID!) {
       getInvoiceItem(id: $id) {
            id
            invoiceId
            customerId
            amount
            currency
            description
            period {
                start
                end
            }
            quantity
            unitAmount
            createdByUsername
            created
            updated
       }
}`;
